import COMPANY_POLICIES from './companyPolicies';
import COMPLIANCE from './compliance';
import HELP_CENTER from './helpCenter';
import MINERAL_INTELLIGENCE from './mineralIntelligence';
import PARTNER_TOOLS from './partnerTools';
import RESOURCES from './resources';
import SAFETY from './safety';
import TEMPLATES from './templates';
import TOOLS from './tools';
import TRAINING from './training';
import BDC from './bdc';
import COMMUNITY from './community';

const VISIT_LOGS = {
    BDC,
    COMMUNITY,
    COMPANY_POLICIES,
    COMPLIANCE,
    HELP_CENTER,
    MINERAL_INTELLIGENCE,
    PARTNER_TOOLS,
    RESOURCES,
    SAFETY,
    TEMPLATES,
    TOOLS,
    TRAINING,
};

export default VISIT_LOGS;
